import React from 'react';

export const mailToLink = (chunk: React.ReactNode) => {
	return (
		<a className={'underline'} rel='noreferrer' href={`mailto:${chunk}`}>
			{chunk}
		</a>
	);
};

export const boldText = (chunk: React.ReactNode) => {
	return <b>{chunk}</b>;
};

export const linkText = (chunk: React.ReactNode, url: string) => {
	return (
		<a href={url} target='_blank' className='underline cursor-pointer' rel='noreferrer'>
			{chunk}
		</a>
	);
};

export const italicText = (chunk: React.ReactNode, blank?: boolean, url?: string) => {
	const newChunk = '"' + chunk + '"';

	if (url) {
		return (
			<a href={url} target={`${blank ? '_blank' : '_parent'}`} className='cursor-pointer' rel='noreferrer'>
				<i style={{ color: '#3F8CFF' }}>{newChunk}</i>
			</a>
		);
	}

	return <i className='font-semibold'>{newChunk}</i>;
};
